import { styled } from 'styled-components';

export const Container = styled.div`
  .chakra-modal__header {
    h2 {
      color: ${({ theme }) => theme.colors.blue03.color} !important;
    }
  }

  .chakra-accordion__button {
    padding: 0.8rem 1.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    font-size: 1.125rem;
    font-weight: bold;
    text-transform: uppercase;

    border-bottom: 1px solid ${({ theme }) => theme.colors.border};

    svg {
      width: 2.5rem;
      height: 2.5rem;
    }
  }

  .chakra-accordion__panel {
    padding-top: 0;
    -webkit-padding-start: 0;
    padding-inline-start: 0;
    -webkit-padding-end: 0;
    padding-inline-end: 0;
    padding-bottom: 0;
  }

  .chakra-collapse {
    span {
      margin: 0;
    }

    .checkbox {
      background: ${({ theme }) => theme.colors.light.color};
      border-bottom: 1px solid ${({ theme }) => theme.colors.border};

      label {
        padding: 1rem 1.5rem;
        width: 100%;
        gap: 1rem;
        flex-direction: row-reverse;
        justify-content: space-between;
      }
    }
  }
`;

export const FooterFilter = styled.div`
  padding: 1rem 2rem;

  button {
    width: 100%;
  }
`;
